import { Stack, Typography, ThemeProvider, Box } from '@mui/material'
import { useEffect } from 'react'
import { MainTemplate } from 'Components/Template/MainTemplate'
import SessionAuth from 'GlobalStores/User/SessionAuth'

const ResetPage = () => {
    useEffect(() => {
        SessionAuth.ResetSessionStorage()

        setTimeout(() => {
            const base = window.location.pathname.replace(/\/reset$/, '') || '/'
            window.location.replace(base)
        }, 1000)
    }, [])

    return (
        <ThemeProvider theme={MainTemplate}>
            <Stack minHeight="100vh" alignItems="center" justifyContent="center" bgcolor="#f4f7fa" padding="24px">
                <Box sx={{ maxWidth: 480, width: '100%', bgcolor: '#fff', borderRadius: '12px', padding: '40px 32px', textAlign: 'center', boxShadow: 'none' }}>
                    <Stack gap="12px" alignItems="center">
                        <Typography variant="h3">Resetting Session…</Typography>
                        <Typography variant="body2" color="#5A8FC3">
                            Clearing session data and redirecting.
                        </Typography>
                    </Stack>
                </Box>
            </Stack>
        </ThemeProvider>
    )
}

export default ResetPage
